/* global ajaxPath */

import $ from 'jquery';
import loadMoreLogos from './load-more-logos';

const listingFilters = {
  titleFilter: ['all-titles'],
  listingElementList: [],
  sending: false,
  blockContainer: false,

  init: (blockContainer) => {
    // return false if our block doesnt exist
    if (!$(blockContainer).length) return false;

    // listing element passed from app.js
    listingFilters.blockContainer = document.querySelector(blockContainer);

    // Get filter and listing elements
    const filterElementList = listingFilters.blockContainer.querySelectorAll('.category-filter li');
    const listingElementList = listingFilters.blockContainer.querySelectorAll('.item');

    const checkbox = document.querySelector('.select-checkbox');
    const labelSelect = document.querySelector('.select-label');

    // filter click handlers
    filterElementList.forEach((option) => {
      option.addEventListener('click', () => {
        labelSelect.innerHTML = option.textContent;
        checkbox.checked = false;
      });
    });

    listingElementList.forEach((listingElement, i) => {
      // set initial index
      $(listingElement).data('initial-index', i);
      // push to our element list array
      listingFilters.listingElementList.push(listingElement);
    });

    filterElementList.forEach((filterElement) => {
      // Add click event listener for filter item selection
      filterElement.addEventListener(
        'click',
        (e) => {
          listingFilters.handleFilterClick(e, filterElementList, listingFilters.listingElementList);
        },
        false
      );

      // For keyboard navigation, when user clicks enter, select filter button
      filterElement.addEventListener(
        'keypress',
        (e) => {
          if (e.key === 'Enter') {
            listingFilters.handleFilterClick(
              e,
              filterElementList,
              listingFilters.listingElementList
            );
          }
        },
        false
      );

      // remove focus when user clicks filter, it shows for keyboard navigation only
      filterElement.addEventListener('mousedown', (e) => {
        e.preventDefault();
      });
    });
  },

  handleFilterClick: (e, filterElementList, listingElementList) => {
    // Get height to pass filterAjaxGetPosts to prevent dom elements jumping
    const listingWrapper = listingFilters.blockContainer.querySelector('.listing-wrapper');
    const height = listingWrapper.offsetHeight;

    listingFilters.updateFilterClasses(e, filterElementList);
    listingFilters.updateFilters(e, filterElementList);
    listingFilters.updateDisplayedItems(listingElementList);
    listingFilters.filterAjaxGetPosts(e, height);
  },

  updateFilterClasses: (e, filterElementList) => {
    // Add/Remove active class from items
    // Checks if click is on Single Filter
    if (e.target.closest('li').parentElement.classList.contains('category-filter')) {
      filterElementList.forEach((filterElement) => {
        filterElement.classList.remove('active');
      });
    }
    // Add Active Class if filter item is not already Active
    if (!e.target.closest('li').classList.contains('active')) {
      e.target.closest('li').classList.add('active');
      // Else Remove active class if it is already there.
    } else {
      e.target.closest('li').classList.remove('active');
    }
    //If all other filters are removed, return to all-titles
    if (
      !Array.from(filterElementList).some((filterElement) => {
        filterElement.classList.contains('active');
        return false;
      })
    ) {
    }
  },

  updateFilters: (e, filterElementList) => {
    // Add/Remove filters from title-filter List
    if (
      e.target.closest('li').parentElement.classList.contains(`category-filter`) ||
      e.target.closest('li').parentElement.classList.contains(`title-filter`)
    ) {
      // Clear current filter list
      listingFilters.categoryFilter = [];
      listingFilters.titleFilter = [];

      // Iterate over filter items and push them to filter list if they are active.
      filterElementList.forEach((filterElement) => {
        if (filterElement.classList.contains('active')) {
          listingFilters.categoryFilter.push(filterElement.dataset.category);
          listingFilters.titleFilter.push(filterElement.dataset.title);
        }
      });
    }
  },

  sortItems: (itemArray, attrName = 'initial-index') => {
    return itemArray.sort(function (a, b) {
      const aVal = parseInt($(a).data(attrName)),
        bVal = parseInt($(b).data(attrName));
      return aVal - bVal;
    });
  },

  updateDisplayedItems: (listingElementList) => {
    const listingWrapper = listingFilters.blockContainer.querySelector('.listing-wrapper');
    let filteredElementList = [];

    // add to newList
    listingElementList.forEach((listingElement) => {
      // Check if Array of tags matches any item in the Array of filters
      if (
        listingFilters.titleFilter.some((item) =>
          listingElement.getAttribute('data-titles').includes(item)
        ) ||
        listingFilters.titleFilter.includes('all-titles')
      ) {
        filteredElementList.push(listingElement);
      }
      // detach
      $(listingElement).detach();
    });

    // sort
    filteredElementList = listingFilters.sortItems(filteredElementList);

    // add our elements
    filteredElementList.forEach((listingElement) => {
      $(listingElement).appendTo(listingWrapper);
    });
  },

  updateElementList(listingWrapper) {
    // update element list
    const listingElementList = Array.from(listingWrapper.querySelectorAll('.item'));

    // get last item from our current element list
    const lastIndexedElement = listingFilters.sortItems(listingFilters.listingElementList)[
      listingFilters.listingElementList.length - 1
    ];

    // its index
    const elementIndex = $(lastIndexedElement).data('initial-index');

    listingElementList.forEach((listingElement, i) => {
      const newElements = [];

      if (!listingFilters.listingElementList.includes(listingElement)) {
        $(listingElement).data('initial-index', i + elementIndex);
        newElements.push(listingElement);
        listingFilters.updateDisplayedItems(newElements);
        newElements.forEach((element) => {
          listingFilters.listingElementList.push(element);
        });
      }
    });
  },

  // AJAX call when user clicks filter
  filterAjaxGetPosts: (e, height) => {
    const listingWrapper = listingFilters.blockContainer.querySelector('.listing-wrapper');

    $(listingWrapper).css('height', height);

    listingWrapper.innerHTML = '';

    const postType = listingWrapper.dataset.posttype;
    // Get category type from filter button
    const category = e.target.getAttribute('data-title');
    const currentPage = parseInt(listingWrapper.dataset.currentpage);
    const currentPostList = listingWrapper.getAttribute('data-exclude');
    const offset = currentPage % 2 === 0 ? 16 : 17;

    // Set data for AJAX call
    const callData = {
      action: 'filter_logos',
      post_type: postType,
      exclude_posts: currentPostList,
      numberposts: offset,
      category,
    };

    $.ajax({
      url: ajaxPath.admin_path,
      data: callData,
      type: 'POST',
      beforeSend() {
        if (!listingFilters.sending) {
          // Insert loading spinner as visual indication to user.
          // listingContainer.insertAdjacentHTML(
          //   'beforeend',
          //   `<div class="spinner">
          //         <div class="rect1"></div>
          //         <div class="rect2"></div>
          //         <div class="rect3"></div>
          //         <div class="rect4"></div>
          //         <div class="rect5"></div>
          //     </div>`
          // );
          // Set sending state to true.
          listingFilters.sending = true;
        }
      },
      success(response) {
        listingFilters.sending = false;

        loadMoreLogos.totalOffset = 0;

        // Insert query response at bottom of container element.
        listingWrapper.insertAdjacentHTML('beforeend', response);
        const children = Array.from(listingWrapper.getElementsByTagName('article'));
        const newTotal = children.length;
        listingWrapper.dataset.totalitems = newTotal;

        children.forEach((child, i) => {
          if (i > 15) {
            child.remove();
          }
        });

        // update our element list
        listingFilters.updateElementList(listingWrapper);

        // Increase page count to represent current page of items.
        listingWrapper.dataset.currentpage = 1;

        // check if we need our load more button
        const allChildren = listingWrapper.querySelectorAll('.item').length;
        const loadMoreButton = listingWrapper.parentElement.querySelector('.load-more-btn');

        // hide our load more if we need to
        if (parseInt(listingWrapper.dataset.totalitems) === allChildren) {
          loadMoreButton.classList.add('hide');
        } else {
          loadMoreButton.classList.remove('hide');
        }

        $(listingWrapper).css('height', 'auto');

        setTimeout(() => {
          Array.from(listingWrapper.children).forEach((child) => child.classList.remove('hide'));
        }, 400);
      },
    });
  },
};

export default listingFilters;
